<template>
  <div>
    <ContentBox title="所属项目计划">
      <el-form class="demo-ruleForm" label-width="117px" label-position="left">
        <el-form-item label="订单名称">{{ orderScheduleForm.orderName }}</el-form-item>
        <el-form-item label="计划名称">{{ orderScheduleForm.scheduleName }}</el-form-item>
      </el-form>
    </ContentBox>
    <!-- 程序化创意表单 -->
    <MaterialProgrammatic
      v-if="orderScheduleForm.scheduleSource !== 0"
      ref="programmatic"
      :sdkProviderList="sdkProviderList"
      :scheduleForm="orderScheduleForm"
      @go-back="$emit('go-back')"
    />
    <!-- 自有源创意表单 -->
    <MaterialOwnSource
      v-else
      :sdkProviderList="sdkProviderList"
      :scheduleForm="orderScheduleForm"
      @go-back="$emit('go-back')"
    />
  </div>
</template>

<script>
import MaterialProgrammatic from './MaterialProgrammatic.vue'
import MaterialOwnSource from './MaterialOwnSourse.vue'
import { computed } from 'vue'

export default {
  components: {
    MaterialProgrammatic,
    MaterialOwnSource
  },
  props: {
    orderScheduleForm: {
      type: Object
    }
  },
  data() {
    return {
      sdkProviderList: [],
      eventTempList: [],
    }
  },
  provide() {
    return {
      eventTempList: computed(() => this.eventTempList)
    }
  },
  async created() {
    this.getBaseDict()
    this.eventTempList = await this.$service.getTargetTemp({})
  },
  methods: {
    getBaseDict() {
      this.$service.getBaseDict().then(data => {
        this.sdkProviderList = (data.sdkProviderList || []).map(item => {
          return {
            providerName: item.dictLabel,
            providerNo: item.dictValue,
          }
        })
      })
    }
  }
}
</script>
